import React, { useCallback } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";

import XtSvg from "@/components/Xt/Svg";

import styles from "./index.module.scss";

const { useTranslation } = Hooks;

interface Props {
  sortBy: string | undefined;
  onChange: (item: string | undefined) => void;
  isShowVolume: boolean;
  setIsShowVolume: (arg: boolean) => void;
}

const Main: React.FC<Props> = ({ sortBy, onChange, isShowVolume, setIsShowVolume }) => {
  const t = useTranslation();

  const getCls = useCallback(
    (attr) => {
      if (!sortBy) return;
      const ary = sortBy.split("_");
      if (attr !== ary[0]) return;
      return ary[1];
    },
    [sortBy]
  );

  const onClick = useCallback(
    (attr) => {
      let value;
      if (!sortBy) {
        value = attr + "_down";
      } else {
        const ary = sortBy.split("_");
        if (attr !== ary[0]) {
          value = attr + "_down";
        } else if (ary[1] === "down") {
          value = attr + "_up";
        } else {
          value = "";
        }
      }

      onChange(value);
    },
    [sortBy, onChange]
  );

  return (
    <div className={styles.main}>
      <div>
        <button className={cx("btnTxt", styles.btnFilter, getCls("name"))} onClick={() => onClick("name")}>
          {t("trade.pairs")}
        </button>
      </div>
      <div>
        <button className={cx("btnTxt", styles.btnFilter, getCls("price"))} onClick={() => onClick("price")}>
          {t("trade.lastPrice")}
        </button>
      </div>
      <div>
        {isShowVolume ? (
          <button className={cx("btnTxt", styles.btnFilter, getCls("volume"))} onClick={() => onClick("volume")}>
            {t("trade.volume")}
          </button>
        ) : (
          <button className={cx("btnTxt", styles.btnFilter, getCls("rate"))} onClick={() => onClick("rate")}>
            {t("trade.change")}
          </button>
        )}
        <button className={cx("btnTxt")} onClick={() => setIsShowVolume(!isShowVolume)}>
          <XtSvg icon={"transfer"} />
        </button>
      </div>
    </div>
  );
};

export default Main;
